/* Fit Quiz interno: taglia consigliata.
 * Dati dal prodotto (snippets/custom-fit-quiz.liquid), profilo cliente solo nel browser (localStorage).
 * Il calcolo replica il quiz dell'app Fit Quiz: i pesi sono stati stimati confrontando centinaia di risposte (vedi CONFIG).
 */
(function () {
  'use strict';

  var STD = ['2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL'];
  var ALIAS = { XXS: '2XS', XXL: '2XL' };
  var COLOR_OPTIONS = ['colore', 'color', 'colour', 'colori', 'title'];
  var STORE_KEY = 'fq_profile_v1';

  /* Pesi del calcolo (in taglie). Somma: taglia abituale + spostamento del prodotto + correzioni, poi arrotondamento
   * con soglia "tau" (floor(somma + tau)). */
  var CONFIG = {
    top: { alwaysSmaller: -0.375, alwaysLarger: 0.375, bellyFlat: -0.125, chestNarrow: -0.25, tau: 0.65 },
    bottom: { alwaysSmaller: 0, alwaysLarger: 0.5, bellyFlat: -0.125, hipsFlat: -0.125, tau: 0.55 }
  };
  CONFIG.dress = CONFIG.top;
  CONFIG.generic = CONFIG.top;

  /* Nei set (due taglie) la parte superiore dell'app si comporta in modo un po' diverso: pesi dedicati,
   * tarati su 114 compilazioni. La parte inferiore usa gli stessi pesi degli slip. */
  var CONFIG_SET = {
    top: { alwaysSmaller: -0.5, alwaysLarger: 0.25, bellyFlat: -0.125, chestNarrow: 0, fitLoose: 0.25, tau: 0.6 }
  };

  /* Il tema ricostruisce il blocco quando cambia la variante e può rieseguire questo script: va avviato una volta sola. */
  if (window.__fqInit) return;
  window.__fqInit = true;

  var T = null;

  function norm(v) {
    var s = String(v == null ? '' : v).trim().toUpperCase();
    return ALIAS[s] || s;
  }

  function lc(v) { return String(v == null ? '' : v).trim().toLowerCase(); }

  function hasKeyword(text, list) {
    text = lc(text);
    return list.some(function (k) { return text.indexOf(k) !== -1; });
  }

  /* Un "contesto" per ogni prodotto con quiz presente nella pagina (scheda prodotto o acquisto rapido). */
  var contexts = new WeakMap();

  function getCtx(root) {
    if (contexts.has(root)) return contexts.get(root);

    var raw = root.querySelector('script[data-fq-data]');
    if (!raw) return null;
    var data;
    try { data = JSON.parse(raw.textContent); } catch (e) { return null; }

    if (!T) {
      /* Le traduzioni arrivano con le entità HTML (es. &#39;): le decodifico una volta. */
      var decoder = document.createElement('textarea');
      T = {};
      Object.keys(data.i18n).forEach(function (k) { decoder.innerHTML = data.i18n[k]; T[k] = decoder.value; });
    }

    /* Parole italiane dalle impostazioni del tema + parole inglesi sempre attive: nelle pagine in inglese
     * titolo e opzioni sono tradotti (es. "Brazilian briefs", "Mini Dress", "Skirt/Crop"). */
    var bottomKeywords = String(data.keywordsBottom || '').split(',').map(lc).filter(Boolean)
      .concat(['brief', 'thong', 'bottom', 'pants', 'trousers', 'skirt', 'shorts', 'trunks', 'leggings', 'brazilian']);
    var dressKeywords = String(data.keywordsDress || '').split(',').map(lc).filter(Boolean)
      .concat(['dress', 'jumpsuit', 'playsuit', 'bodysuit', 'one-piece', 'one piece', 'cover-up', 'cover up', 'robe']);
    var topKeywords = ['top', 'reggiseno', 'fascia', 'bikini', 'bralette', 'bandeau'];

    /* Tipo di capo, solo per scegliere testo della domanda e correzioni: bottom / top / dress / generic. */
    function detectType(optionName) {
      if (hasKeyword(optionName, bottomKeywords)) return 'bottom';
      if (hasKeyword(optionName, topKeywords)) return 'top';
      if (hasKeyword(data.title, bottomKeywords)) return 'bottom';
      if (hasKeyword(data.title, dressKeywords)) return 'dress';
      if (hasKeyword(data.title, topKeywords)) return 'top';
      return 'generic';
    }

    var sizeOptions = [];
    data.options.forEach(function (name, index) {
      if (COLOR_OPTIONS.indexOf(lc(name)) !== -1) return;

      var values = [];
      var avail = {};
      data.variants.forEach(function (v) {
        var val = v.o[index];
        if (val == null) return;
        if (values.indexOf(val) === -1) values.push(val);
        if (v.a) avail[norm(val)] = true;
      });
      if (!values.length) return;

      var isStd = values.every(function (v) { return STD.indexOf(norm(v)) !== -1; });

      sizeOptions.push({
        name: name,
        index: index,
        values: values,
        avail: avail,
        type: detectType(name),
        scale: isStd ? STD : values.map(norm),
        labels: isStd ? STD.slice(1, -1) : values /* risposte da XS a XL: 2XS e 2XL restano solo nella scala di calcolo */
      });
    });

    var ctx = null;
    if (sizeOptions.length) {
      ctx = {
        root: root,
        data: data,
        sizeOptions: sizeOptions,
        needsChest: sizeOptions.some(function (o) { return o.type !== 'bottom'; }),
        needsHips: sizeOptions.some(function (o) { return o.type === 'bottom'; }),
        scope: root.closest('quick-buy-modal') || document
      };
    }
    contexts.set(root, ctx);
    return ctx;
  }

  /* ---------- profilo (solo browser) ---------- */
  function loadProfile() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function saveProfile(p) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(p)); } catch (e) { /* storage non disponibile */ }
  }
  function clearProfile() {
    try { localStorage.removeItem(STORE_KEY); } catch (e) { /* ignora */ }
  }

  /* ---------- calcolo ---------- */
  function isHiddenSize(ctx, option, sizeValue) {
    var fs = findFieldset(ctx, option);
    if (!fs) return false;
    var hidden = false;
    fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var label = input.id ? ctx.scope.querySelector('label[for="' + input.id + '"]') : null;
      if (!label) return;
      var span = label.querySelector('span');
      if (norm((span || label).textContent) === norm(sizeValue) && label.style.display === 'none') hidden = true;
    });
    return hidden;
  }

  function compute(ctx, profile) {
    var results = [];
    var sizeOptions = ctx.sizeOptions;
    var data = ctx.data;
    for (var i = 0; i < sizeOptions.length; i++) {
      var o = sizeOptions[i];
      var usual = profile.usual && profile.usual[o.type];
      if (!usual || !profile.always || !profile.belly) return null;
      if (o.type !== 'bottom' && !profile.chest) return null;
      if (o.type === 'bottom' && !profile.hips) return null;

      var cfg = (sizeOptions.length > 1 && CONFIG_SET[o.type]) || CONFIG[o.type];
      var idx = o.scale.indexOf(norm(usual));
      if (idx === -1) { results.push({ option: o, size: null }); continue; }

      var s = idx + Number(data.shift);
      if (profile.always === 'smaller') s += cfg.alwaysSmaller;
      if (profile.always === 'larger') s += cfg.alwaysLarger;
      if (profile.belly === 'flat') s += cfg.bellyFlat;
      if (profile.fit === 'loose') s += cfg.fitLoose || 0;
      if (profile.fit === 'tight') s += cfg.fitTight || 0;
      if (o.type !== 'bottom' && profile.chest === 'narrow') s += cfg.chestNarrow;
      if (o.type === 'bottom' && profile.hips === 'flat') s += cfg.hipsFlat;

      var t = Math.floor(s + cfg.tau);

      /* Taglie del prodotto (non nascoste) con la loro posizione sulla scala. */
      var candidates = [];
      o.values.forEach(function (v) {
        var pos = o.scale.indexOf(norm(v));
        if (pos !== -1 && !isHiddenSize(ctx, o, v)) candidates.push({ value: v, pos: pos });
      });

      /* Mai "nessuna taglia": se quella ideale non esiste nel prodotto si propone la più vicina.
       * A parità di distanza si sceglie la più grande. */
      var size = null;
      var soldOut = false;
      var closest = false;
      var far = false;
      var best = null;
      candidates.forEach(function (c) {
        var dist = Math.abs(c.pos - t);
        if (!best || dist < best.dist || (dist === best.dist && c.pos > best.pos)) best = { value: c.value, pos: c.pos, dist: dist };
      });
      var ideal = o.scale[Math.min(Math.max(t, 0), o.scale.length - 1)];
      if (best) {
        size = best.value;
        soldOut = !o.avail[norm(best.value)];
        closest = best.dist > 0;
        far = best.dist >= 2;
      }
      results.push({ option: o, size: size, soldOut: soldOut, closest: closest, far: far, ideal: ideal });
    }
    return results;
  }

  /* ---------- selettore varianti ---------- */
  function findFieldset(ctx, option) {
    var found = null;
    ctx.scope.querySelectorAll('variant-picker fieldset.variant-picker__option').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (legend && lc(legend.textContent.replace(':', '')) === lc(option.name)) found = fs;
    });
    return found;
  }

  function selectSize(ctx, option, sizeValue) {
    var fs = findFieldset(ctx, option);
    if (!fs) return;
    fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var label = input.id ? ctx.scope.querySelector('label[for="' + input.id + '"]') : null;
      if (!label) return;
      var span = label.querySelector('span');
      if (norm((span || label).textContent) === norm(sizeValue) && !input.checked && !input.disabled) input.click();
    });
  }

  /* Preme il pulsante "Aggiungi al carrello" del tema, così restano validi carrello laterale e tracciamenti. */
  function addToCart(ctx) {
    var picker = ctx.scope.querySelector('variant-picker[form-id]');
    var formId = picker ? picker.getAttribute('form-id') : '';
    var form = formId ? document.getElementById(formId) : null;
    var btn = null;
    if (formId) {
      btn = document.querySelector('button[type="submit"][form="' + formId + '"]:not([disabled])')
        || (form && form.querySelector('button[type="submit"]:not([disabled])'));
    }
    closeQuiz();
    /* Dà il tempo al tema di aggiornare la variante dopo la selezione della taglia. */
    setTimeout(function () {
      if (btn && document.body.contains(btn)) btn.click();
      else if (form && form.requestSubmit) form.requestSubmit();
    }, 450);
  }

  /* ---------- riga "Taglia consigliata per te" ---------- */
  function renderReco(ctx) {
    ctx.scope.querySelectorAll('.fq-reco').forEach(function (el) { el.remove(); });

    var profile = loadProfile();
    var results = compute(ctx, profile);
    if (!results) return;

    results.forEach(function (res) {
      var fs = findFieldset(ctx, res.option);
      if (!fs) return;
      var line = document.createElement('div');
      line.className = 'fq-reco';

      if (res.size) {
        var label = document.createElement('span');
        label.textContent = T.recoLabel + ' ';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fq-reco__size';
        btn.textContent = res.size;
        if (res.soldOut) btn.title = T.soldOut;
        btn.addEventListener('click', function () { selectSize(ctx, res.option, res.size); });
        line.appendChild(label);
        line.appendChild(btn);
        if (res.closest) line.appendChild(el('span', 'fq-reco__note', '(' + T.closestTag + ')'));
        if (res.soldOut) line.appendChild(el('span', 'fq-reco__note', '(' + T.soldOut + ')'));
      } else {
        var none = document.createElement('span');
        none.textContent = T.recoNone;
        line.appendChild(none);
      }

      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'fq-reco__link';
      clear.textContent = T.recoClear;
      clear.addEventListener('click', function () { clearProfile(); renderAllReco(true); });
      line.appendChild(clear);

      fs.appendChild(line);
    });
  }

  function eachContext(fn) {
    document.querySelectorAll('.fq-root').forEach(function (root) {
      var ctx = getCtx(root);
      if (ctx) fn(ctx);
    });
  }

  function renderAllReco(force) {
    eachContext(function (ctx) {
      if (force || !ctx.scope.querySelector('.fq-reco')) renderReco(ctx);
    });
  }

  /* ---------- quiz ---------- */
  var overlay = null;
  var fqBody = null;
  var active = null;
  var steps = [];
  var current = 0;
  var answers = {};

  function buildSteps() {
    steps = [];
    var ctx = active;
    ctx.sizeOptions.forEach(function (o) {
      var existing = steps.filter(function (s) { return s.key === 'usual-' + o.type; })[0];
      if (existing) return;
      steps.push({
        key: 'usual-' + o.type,
        type: 'choice',
        title: ({ bottom: T.qUsualBottom, top: T.qUsualTop, dress: T.qUsualDress, generic: T.qUsualGeneric })[o.type],
        options: o.labels.map(function (l) { return { value: l, label: l }; }),
        set: function (v) { answers.usual = answers.usual || {}; answers.usual[o.type] = v; }
      });
    });
    steps.push({
      key: 'always', type: 'choice', title: T.qAlways,
      options: [
        { value: 'smaller', label: T.aAlwaysSmaller },
        { value: 'yes', label: T.aAlwaysYes },
        { value: 'larger', label: T.aAlwaysLarger }
      ],
      set: function (v) { answers.always = v; }
    });
    steps.push({
      key: 'belly', type: 'choice', title: T.qBelly,
      options: [{ value: 'flat', label: T.aFlat }, { value: 'mid', label: T.aMedium }, { value: 'round', label: T.aRound }],
      set: function (v) { answers.belly = v; }
    });
    if (ctx.needsChest) {
      steps.push({
        key: 'chest', type: 'choice', title: T.qChest,
        options: [{ value: 'narrow', label: T.aNarrow }, { value: 'wide', label: T.aWide }],
        set: function (v) { answers.chest = v; }
      });
    }
    if (ctx.needsHips) {
      steps.push({
        key: 'hips', type: 'choice', title: T.qHips,
        options: [{ value: 'flat', label: T.aFlat }, { value: 'mid', label: T.aMedium }, { value: 'round', label: T.aRound }],
        set: function (v) { answers.hips = v; }
      });
    }
    steps.push({ key: 'height', type: 'height', title: T.qHeight, set: function (v) { answers.height = v; } });
    steps.push({
      key: 'fit', type: 'choice', title: T.qFit,
      options: [
        { value: 'tight', label: T.aFitTight },
        { value: 'regular', label: T.aFitRegular },
        { value: 'loose', label: T.aFitLoose }
      ],
      set: function (v) { answers.fit = v; }
    });
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function ensureOverlay() {
    if (overlay) return;
    overlay = el('div', 'fq-overlay');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', T.title);

    var drawer = el('div', 'fq-drawer');
    var header = el('div', 'fq-header');
    header.appendChild(el('span', 'fq-title', T.title));
    var close = el('button', 'fq-close');
    close.type = 'button';
    close.setAttribute('aria-label', T.close);
    close.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';
    close.addEventListener('click', closeQuiz);
    header.appendChild(close);

    var body = el('div', 'fq-body');
    body.id = 'fq-body';
    fqBody = body;

    drawer.appendChild(header);
    drawer.appendChild(body);
    overlay.appendChild(drawer);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeQuiz(); });
    document.body.appendChild(overlay);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuiz(); });
  }

  /* Nell'acquisto rapido la finestra del tema non deve chiudersi mentre il quiz è aperto (stesso metodo della guida taglie). */
  function patchQuickBuy() {
    var qbm = document.querySelector('quick-buy-modal');
    if (!qbm) return;
    var proto = Object.getPrototypeOf(qbm);
    if (proto._fqHidePatched) return;
    var origHide = proto.hide;
    if (typeof origHide !== 'function') return;
    proto.hide = function () {
      if (window._fqOpen) return;
      return origHide.apply(this, arguments);
    };
    /* Il tema blocca tocco e clic fuori dalla finestra dell'acquisto rapido: lasciamo passare quelli sul quiz. */
    var origHideFor = proto.hideForOutsideClickTarget;
    var origAllow = proto.allowOutsideClickForTarget;
    function inQuiz(t) { return !!(t && t.closest && t.closest('.fq-overlay')); }
    if (typeof origHideFor === 'function') {
      proto.hideForOutsideClickTarget = function (t) { return inQuiz(t) ? false : origHideFor.apply(this, arguments); };
    }
    if (typeof origAllow === 'function') {
      proto.allowOutsideClickForTarget = function (t) { return inQuiz(t) ? true : origAllow.apply(this, arguments); };
    }
    proto._fqHidePatched = true;
  }

  function openQuiz(ctx) {
    active = ctx;
    ensureOverlay();
    patchQuickBuy();
    window._fqOpen = true;
    answers = {};
    buildSteps();
    current = 0;
    renderStep();
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    document.documentElement.classList.add('fq-lock');
  }

  function closeQuiz() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('fq-lock');
    /* Il flag resta attivo un attimo, così lo stesso clic non chiude anche l'acquisto rapido. */
    setTimeout(function () { window._fqOpen = false; }, 120);
  }

  function renderStep() {
    var body = fqBody;
    body.innerHTML = '';
    var step = steps[current];

    var progress = el('div', 'fq-progress');
    var bar = el('div', 'fq-progress__bar');
    bar.style.width = ((current + 1) / steps.length * 100) + '%';
    progress.appendChild(bar);
    body.appendChild(progress);

    var count = el('p', 'fq-count', T.progress.replace('__C__', current + 1).replace('__T__', steps.length));
    body.appendChild(count);
    body.appendChild(el('h2', 'fq-question', step.title));

    if (step.type === 'choice') {
      var list = el('div', 'fq-options');
      step.options.forEach(function (opt) {
        var b = el('button', 'fq-option', opt.label);
        b.type = 'button';
        b.addEventListener('click', function () { step.set(opt.value); advance(); });
        list.appendChild(b);
      });
      body.appendChild(list);
    } else {
      var wrap = el('div', 'fq-height');
      var value = el('p', 'fq-height__value', '170 ' + T.unitCm);
      var range = el('input', 'fq-height__range');
      range.type = 'range'; range.min = 150; range.max = 220; range.step = 1; range.value = 170;
      range.setAttribute('aria-label', T.qHeight);
      range.addEventListener('input', function () { value.textContent = range.value + ' ' + T.unitCm; });
      var next = el('button', 'fq-primary', T.next);
      next.type = 'button';
      next.addEventListener('click', function () { step.set(Number(range.value)); advance(); });
      wrap.appendChild(value); wrap.appendChild(range); wrap.appendChild(next);
      body.appendChild(wrap);
    }

    if (current > 0) {
      var back = el('button', 'fq-back', T.back);
      back.type = 'button';
      back.addEventListener('click', function () { current -= 1; renderStep(); });
      body.appendChild(back);
    }
  }

  function advance() {
    if (current < steps.length - 1) { current += 1; renderStep(); } else { finish(); }
  }

  function finish() {
    var profile = {
      usual: answers.usual,
      always: answers.always === 'yes' ? 'yes' : answers.always,
      belly: answers.belly,
      chest: answers.chest || (loadProfile().chest || null),
      hips: answers.hips || (loadProfile().hips || null),
      height: answers.height,
      fit: answers.fit
    };
    var old = loadProfile();
    profile.usual = Object.assign({}, old.usual || {}, answers.usual || {});
    saveProfile(profile);

    var ctx = active;
    var results = compute(ctx, profile) || [];
    var body = fqBody;
    body.innerHTML = '';
    body.appendChild(el('h2', 'fq-question', T.resultTitle));

    var anySize = results.some(function (r) { return r.size; });
    if (anySize) {
      body.appendChild(el('p', 'fq-intro', T.resultIntro));
      results.forEach(function (r) {
        var row = el('div', 'fq-result');
        row.appendChild(el('span', 'fq-result__label', T.resultLabel + (results.length > 1 ? ' – ' + r.option.name : '')));
        row.appendChild(el('span', 'fq-result__size', r.size || '—'));
        body.appendChild(row);
        if (r.size && r.closest) body.appendChild(el('p', 'fq-intro fq-soldout', (r.far ? T.closestFarNote : T.closestNote).replace('__I__', r.ideal).replace('__S__', r.size)));
        if (r.size && r.soldOut) body.appendChild(el('p', 'fq-intro fq-soldout', T.soldOutNote));
        if (r.size) selectSize(ctx, r.option, r.size);
      });
      /* "Aggiungi al carrello" solo se tutte le taglie consigliate sono disponibili. */
      var canAdd = results.every(function (r) { return r.size && !r.soldOut; });
      if (canAdd) {
        var add = el('button', 'fq-primary', T.addToCart);
        add.type = 'button';
        add.addEventListener('click', function () { addToCart(ctx); });
        body.appendChild(add);
      }
      var go = el('button', canAdd ? 'fq-secondary' : 'fq-primary', T.continue);
      go.type = 'button';
      go.addEventListener('click', closeQuiz);
      body.appendChild(go);
    } else {
      body.appendChild(el('p', 'fq-intro fq-intro--strong', T.noSize));
      body.appendChild(el('p', 'fq-intro', T.noSizeNote));
      var shop = el('button', 'fq-primary', T.backToShop);
      shop.type = 'button';
      shop.addEventListener('click', closeQuiz);
      body.appendChild(shop);
    }

    var again = el('button', 'fq-restart');
    again.type = 'button';
    again.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>';
    again.appendChild(el('span', null, T.retake));
    again.addEventListener('click', function () { answers = {}; current = 0; renderStep(); });
    body.appendChild(again);

    renderAllReco(true);
  }

  /* ---------- avvio ---------- */
  /* Il tema ricostruisce il blocco quando cambia la variante: il clic è quindi collegato al documento. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('#fq-trigger');
    if (!t) return;
    var root = t.closest('.fq-root');
    var ctx = root && getCtx(root);
    if (ctx) openQuiz(ctx);
  });

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      renderAllReco(false);
    });
  }

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('variant:changed', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
